import React, {useEffect} from 'react'
import Section from '../Section'
import GrayLine from '../../../images/goDigital/Professional/Gray-Line.svg'
import BlueLine from '../../../images/goDigital/Professional/Blue-Line.svg'
import useWindowSize from '../../../hooks/useWindowSize'
import SingleVisitSlider from '../../../components/landingPage/MainBanner/Slides/Professional/SingleVisitSlider'

const GRAY_TEXT= {
  transform:"translateX(0rem)"
}
const BLUE_TEXT= {
  transform:"translateX(0rem)"
}

const LINE_STYLE = {
  width: "38px",
  height: "2px",
  borderTop: "2px solid #3A3A3A",
  transform: "translate(-16px, 2px)"
}
 
const ARROW_STYLE = {
  borderLeft: "2px solid #3A3A3A",
  borderTop: "2px solid #3A3A3A",
  transform: "rotate(-45deg) translate(0px, -4px)"
}

const ARROW_POSITION = {
  transform: "translate(-46px, 10px)"
}

const BLUE_LINE_STYLE ={
  width: "140px",
  height: "2px",
  borderTop: "2px solid #006BB7",
  transform: "translate(12px, 5px)"
}

const BLUE_ARROW_STYLE = {
  borderRight: "2px solid #006BB7",
  borderBottom: "2px solid #006BB7",
  transform: "rotate(-45deg) translate(0px, 0px)"
}

const BLUE_ARROW_POSITION = {
  transform: "translate(74px, 6px)"
}



function GoDigital() {

  const size=useWindowSize();

  return (
    <Section className="mx-auto text-center py-8 md:py-12" id="GoDigital" title="Choose AI & Go Fully Digital with XiViX" subtitle="The Future of dentistry is here & embracing technology is the only way forward.
    Becoming a XiViX Partner lets you leverage the power of a global dental network & cutting-edge, high-precision AI-technology & engineering.">
      <h3 className="text-3xl font-semibold my-6 text-primary">Think. Innovate. Lead</h3>
      <div className="flex flex-col h-full">
        <div className="flex justify-center">
          <div className="bg-gray-600 text-white font-semibold text-xl py-0 sm:py-5 w-1/2 sm:w-80 flex flex-col justify-center">Traditional Workflow</div>
          <p className="p-5 text-lpGray text-lg flex flex-col justify-center">VS</p>
          <div className="bg-primary text-white font-semibold text-xl py-0 sm:py-5 w-1/2 sm:w-80 flex flex-col justify-center">XiViX Workflow</div>
        </div>
        <div className="flex justify-center w-full max-w-7xl mx-auto gap-0 md:gap-20" style={{height:size.width<size.tailwind.lg? "400px" : "605px"}}>
          <div className="relative flex justify-center" style={{height:size.width<size.tailwind.lg? "400px" : "605px"}}>
            <div className="absolute inset-y-0 -left-48 lg:-left-44 flex flex-col w-60 justify-between" style={GRAY_TEXT}>
              <div className="mt-12">
                <div className="text-right text-lpGray mb-3" style={{transform: `${size.width<size.tailwind.xl? "translate(0px, -16px)" : ""}`}}>
                  <h1 className={`text-lg font-semibold hidden lg:block`}>Dentist cabinet</h1>
                  <p className="text-sm">Consultation Basic X-rays</p>
                </div>
                <div className="text-right text-lpGray pr-4" style={{transform: `${size.width<size.tailwind.xl? "translate(0px, 4px)" : "translate(0px, 16px)"}`}}>
                  <h1 className={`text-lg font-semibold hidden lg:block`}>Dentist cabinet</h1>
                  <p className="text-sm">Treatment Plan</p>
                </div>
              </div>
              <div className="mr-8">
                <div className="text-right text-lpGray mb-10 pr-1" style={{transform: `${size.width<size.tailwind.xl? "translate(0px, 24px)" : "translate(0px, 24px)"}`}}>
                  <h1 className={`text-lg font-semibold hidden lg:block`}>Dentist cabinet</h1>
                  <p className="text-sm">Conventional Preparation</p>
                </div>
                <div className="text-right text-lpGray pr-2 pb-2" style={{transform: `${size.width<size.tailwind.xl? "translate(0px, 26px)" : "translate(0px, 26px)"}`}}>
                  <h1 className={`text-lg font-semibold hidden lg:block`}>Dentist cabinet</h1>
                  <p className="text-sm">Impressions Occlusion</p>
                </div>
              </div>
              <div className="mb-10">
                <div className="text-right text-lpGray pr-8 mb-16" style={{transform: "translate(0px, 38px)"}}>
                  <h1 className={`text-lg font-semibold hidden lg:block`}>Dentist cabinet</h1>
                  <p className="text-sm">Framework Try-in</p>
                </div>
                <div className="text-right text-lpGray pr-2" style={{transform: "translate(0px, 16px)"}}>
                  <h1 className={`text-lg font-semibold hidden lg:block`}>Dentist cabinet</h1>
                  <p className="text-sm">Placement</p>
                </div>
              </div>
            </div>
          <img alt='gray-line' className="object-contain md:mr-0" src={GrayLine}/>
          </div>
          
          <div className={`xl:flex text-left hidden`}>
            <div className="flex flex-col justify-end mb-16 -mr-14" style={{transform:"translate(-65px, 0px)", width:"190px"}}>
              <div className="mb-20 relative" style={{transform: "translate(0px, -85px)"}}>
                <div className="absolute flex" style={ARROW_POSITION}>
                  <div className="w-3 h-3" style={ARROW_STYLE}></div>
                  <div style={LINE_STYLE}></div> 
                </div>
                <h1>Lab</h1>
                <p className="text-sm text-lpGray">Customized temporary crowns production</p>
              </div>
              <div className="mb-2 relative" style={{transform: "translate(0px, -40px)"}}>
                <div className="absolute flex" style={ARROW_POSITION}>
                  <div className="w-3 h-3" style={ARROW_STYLE}></div>
                  <div style={LINE_STYLE}></div> 
                </div>
                <h1>Lab</h1>
                <p className="text-sm text-lpGray">Master models Framework design & production</p>
              </div>
              <div className="mb-2 relative">
                <div className="absolute flex" style={ARROW_POSITION}>
                  <div className="w-3 h-3" style={ARROW_STYLE}></div>
                  <div style={LINE_STYLE}></div> 
                </div>
                <h1>Lab</h1>
                <p className="text-sm text-lpGray">Ceramic finishing</p>
              </div>
            </div>
            <div className="flex flex-col justify-around -ml-14" style={{transform: "translate(90px, 0px)", width:"190px"}}>
              <div className="pt-28">
                <div className="absolute flex" style={BLUE_ARROW_POSITION}>
                  <div style={BLUE_LINE_STYLE}></div> 
                  <div className="w-3 h-3" style={BLUE_ARROW_STYLE}></div>
                </div>
                <h1 className="text-primary">XiViX CIPP</h1>
                <p className="text-sm text-lpGray">Digital diagnosis Treatment plan</p>
              </div>
              <div className="pb-16">
                <div className="absolute flex" style={BLUE_ARROW_POSITION}>
                  <div style={BLUE_LINE_STYLE}></div> 
                  <div className="w-3 h-3" style={BLUE_ARROW_STYLE}></div>
                </div>
                <h1 className="text-primary">XiViX CIPP</h1>
                <p className="text-sm text-lpGray">Design & milling of crowns + finition</p>
              </div>
            </div>
          </div>
          <div className="relative flex justify-center" style={{height:size.width<size.tailwind.lg? "400px" : "605px"}}>
            <img alt='blue-line' className="object-contain" src={BlueLine}/>
            <div className="absolute inset-y-0 -right-44 lg:-right-56 flex flex-col justify-between pt-12 w-70" style={BLUE_TEXT}>
              <div className="text-left text-primary" style={{transform: `${size.width<size.tailwind.xl? "translate(0px, -15px)" : "translate(0px, -2px)"}`}}>
                <h1 className={`text-lg font-semibold hidden lg:block`}>XiViX CoE</h1>
                <p className="text-sm">Consultation Basic X-rays</p>
              </div>
              <div className="text-left text-primary pb-7 pl-10" style={{transform: `${size.width<size.tailwind.xl? "translate(-10px, -6px)" : "translate(0px, -2px)"}`}}>
                <h1 className={`text-lg font-semibold hidden lg:block`}>XiViX Platform or XiViX CoE</h1>
                <p className="text-sm">Virtual design Validation</p>
              </div>
              <div className="text-left text-primary pl-2" style={{transform: `${size.width<size.tailwind.xl? "translate(0px, -28px)" : "translate(0px, -26px)"}`}}>
                <h1 className={`text-lg font-semibold hidden lg:block`}>XiViX CoE</h1>
                <p className="text-sm">Chairside robotic assisted</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>


  )
}

export default GoDigital
